import { render, staticRenderFns } from "./ExtendedData.vue?vue&type=template&id=96ad7ece"
import script from "./ExtendedData.vue?vue&type=script&lang=js"
export * from "./ExtendedData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports